const translations = {
  "en": {
    "Candle View": "Candle View",
    "Technical Analysis": "Technical Analysis"
  },
  "zh-tw": {
    "Candle View": "K 線圖",
    "Technical Analysis": "技術分析"
  }
};

export default translations;
